import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { api } from "@/lib/api";

const money = (sen) => `RM${(sen / 100).toLocaleString("en-MY", { minimumFractionDigits: sen % 100 ? 2 : 0, maximumFractionDigits: 2 })}`;
const per = (m) => (m === 12 ? "year" : m === 1 ? "month" : `${m} months`);

function Plan({ p, i, cta, to }) {
  return (
    <div className={`asv-card relative flex flex-col p-7 ${p.highlight ? "ring-2 ring-[var(--asv-accent)]" : ""}`} data-testid={`pricing-plan-${i}`}>
      {p.badge && <span className="asv-btn absolute -top-3 right-6 !px-3 !py-1 !text-xs" data-testid={`pricing-plan-${i}-badge`}>{p.badge}</span>}
      <p className="text-sm font-bold uppercase tracking-[0.2em] asv-accent">{p.name}</p>
      <p className="asv-display mt-3 text-4xl font-extrabold sm:text-5xl" data-testid={`pricing-plan-${i}-price`}>{money(p.price_sen)}<span className="asv-muted text-base font-semibold"> / {per(p.months)}</span></p>
      {p.months > 1 && <p className="asv-muted mt-2 text-sm">About {money(Math.round(p.price_sen / p.months))} a month</p>}
      <p className="asv-muted mt-1 text-sm">Every feature included</p>
      <Link to={to} className={`${p.highlight ? "asv-btn" : "asv-btn-ghost"} mt-6 justify-center`} data-testid={`pricing-plan-${i}-cta`}>{cta}<ArrowRight className="h-4 w-4" /></Link>
    </div>
  );
}

export function Pricing({ to }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/asv/pricing").then((r) => setD(r.data)).catch(() => setD(null)); }, []);
  if (!d?.enabled) return null;
  return (
    <section className="mt-20" data-testid="pricing">
      <p className="text-xs font-bold uppercase tracking-[0.3em] asv-accent">Pricing</p>
      <h2 className="asv-display mt-3 text-3xl font-extrabold sm:text-4xl" data-testid="pricing-title">{d.title}</h2>
      {d.subtitle && <p className="asv-muted mt-3 max-w-2xl">{d.subtitle}</p>}
      <div className="mt-10 grid gap-5 md:grid-cols-2">{d.plans.map((p, i) => <Plan key={i} p={p} i={i} cta={d.cta_label} to={to} />)}</div>
      {!!d.groups.length && <div className="asv-card mt-6 grid gap-8 p-7 lg:grid-cols-3" data-testid="pricing-features">
        {d.groups.map((g, gi) => {
          const wide = g.items.length > 14;
          return (
            <div key={gi} className={wide ? "lg:col-span-2" : ""} data-testid={`pricing-group-${gi}`}>
              <p className="font-extrabold">{g.title}</p>
              <ul className={`mt-4 ${wide ? "sm:columns-2 sm:gap-8" : ""}`}>{g.items.map((t, ti) => (
                <li key={ti} className="mb-2.5 flex break-inside-avoid gap-2.5 text-sm"><span className="asv-soft mt-0.5 grid h-5 w-5 shrink-0 place-items-center rounded-full"><Check className="h-3.5 w-3.5 asv-accent" /></span>{t}</li>))}</ul>
            </div>);
        })}
      </div>}
    </section>
  );
}
